export const environment = {
    production: false,
    /*apiurl: 'https://tecnogru.f13comunicazioni.it/api/auth',
    apiurl_admin: 'https://tecnogru.f13comunicazioni.it/api/auth-admin',
    pusher: {
        key: 'e764ddfb369037338890',
        cluster: 'eu',
    }*/

    apiurl: 'https://test.tecnogruspa.it/api/auth',
    apiurl_admin: 'https://test.tecnogruspa.it/api/auth-admin',
    pusher: {
        key: 'e764ddfb369037338890',
        cluster: 'eu',
    }
};
